import React, { useState, useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import axios from "axios";
import MapItem from "../MapItem/MapItem";
import Spinner from "../Spinner/Spinner";
import InputTooltip from "../InputTooltip/InputTooltip";
import "./LittleMapModal.scss";

const LittleMapModal = (props) => {
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [map, setMap] = useState([]);
  const user = useSelector((state) => state.user);

  useEffect(async () => {
    const getMapDetailById = props.getMapDetailById;
    if (getMapDetailById !== null) {
      await axios
        .get(`/account/getAddressById/${getMapDetailById}`, {
          headers: {
            Authorization: "Bearer " + user[0]?.token,
          },
        })
        .then((result) => {
          if (result.status === 200) {
            setMobile(result.data.data.phone);
            setAddress(result.data.data.address);
            let mp = [result.data.data.lat, result.data.data.lng];
            // setMarkerHandler(mp);
            setMap(mp);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    let body = document.body;
    body.style.overflowY = "hidden";
    return () => {
      body.style.overflowY = "auto";
    };
  }, []);

  const setMarkerHandler = (e) => {
    setMap(e.latLng);
  };

  const deleteMapHandler = () => {
    // console.log("deleted!")
  };

  const editMapHandler = () => {
    // console.log("updated...")
  };

  return (
    <div className="mapModalWrapper">
      <div className="LittleMapModal">
        <div className="header">
          <span className="title">{props.title}</span>
          <span className="closeModal" onClick={props.closeModal}>
            <FaTimes />
          </span>
        </div>
        <div className="content">
          <MapItem
            defaultCenter={map.length > 0 ? map : props.defaultCenter}
            anchor={map.length > 0 ? map : props.defaultCenter}
            height={250}
            zoom={14}
            setMarkerHandler={setMarkerHandler}
            deleteMapHandler={deleteMapHandler}
            editMapHandler={editMapHandler}
            active={true}
            twoFingerDrag={true}
          />
          <div className="mapForm">
            <div className="formGroup btn">
              <button className="btnApplyMap" onClick={() => props.submitMapHandler(map)}>
                {props.showSpinner ? <Spinner color="#fff" /> : "ثبت نقشه"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="mapOverlay" onClick={props.closeModal}></div>
    </div>
  );
};

export default React.memo(LittleMapModal);
